import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getBackNavigationTarget } from './back-navigation-policy';
import { IdleNavigationService } from './idle-navigation';

@Injectable()
export class BackNavigationService {
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly idleNavigation = inject(IdleNavigationService);

  public back(ref: readonly string[]): void {
    switch (getBackNavigationTarget(ref)) {
      case 'idle':
        this.idleNavigation.returnToIdle();
        break;
      case 'home':
        void this.router.navigate(['/', 'main', 'home']);
        break;
      case 'history':
        this.location.back();
        break;
    }
  }
}
